module.exports = __webpack_public_path__ + "img/24.efc11c08.jpg";